(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xes-frontend-ui/lib/utils/ajax"), require("xes-frontend-ui/lib/question-tree"));
	else if(typeof define === 'function' && define.amd)
		define(["xes-frontend-ui/lib/utils/ajax", "xes-frontend-ui/lib/question-tree"], factory);
	else if(typeof exports === 'object')
		exports["VueDropUpload"] = factory(require("xes-frontend-ui/lib/utils/ajax"), require("xes-frontend-ui/lib/question-tree"));
	else
		root["VueDropUpload"] = factory(root["xes-frontend-ui/lib/utils/ajax"], root["xes-frontend-ui/lib/question-tree"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_84__, __WEBPACK_EXTERNAL_MODULE_115__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition